@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors.scss';
@import 'node_modules/@gaiads/telia-react-component-library/build/styles/zindex.scss';

.asset-transfer-loading-dim-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: color(overlay);
  z-index: z('modal') + 1; // This is placed over the asset assign modal
}
